// extracted by mini-css-extract-plugin
module.exports = {"root":"faq_root__3XijE","inner":"faq_inner__2H_fT","items":"faq_items__3_DLt"};